export default __webpack_public_path__ + "static/media/aa-logo-light-blue.3a818df3.svg";